export const getCachedProducts = async (productType: "stay" | "occupant" | "global", guiid: number, callback: (response: Response | undefined) => void) => {
    let request = `/productsGlobal.json`;
    let productName = `products-global-cache`;
    if (productType === "occupant" || productType === "stay") {
        request = productType === "stay" ? `/productsStay_${guiid}.json` : `/productsOccupant_${guiid}.json`;
        productName = productType === "stay" ? `products-stay_${guiid}-cache` : `products-occupant_${guiid}-cache`
    }

    const newCache = await caches.open(productName);
    const response = await newCache.match(request);
    callback(response);
}

export const setCachedProducts = async (productType: "stay" | "occupant" | "global", guiid: number, data: string) => {
    let request = `/productsGlobal.json`;
    let productName = `products-global-cache`;

    if (productType === "occupant" || productType === "stay") {
        request = productType === "stay" ? `/productsStay_${guiid}.json` : `/productsOccupant_${guiid}.json`;
        productName = productType === "stay" ? `products-stay_${guiid}-cache` : `products-occupant_${guiid}-cache`;

    }

    const newCache = await caches.open(productName);
    newCache.put(request, new Response(data))
}

export const deleteCachedProducts = () => {
    caches.keys().then((arrayKeys) => {
        arrayKeys.forEach(async (key) => {
            if (key.startsWith("products-")) {
                await caches.delete(key)
            }
        })
    })
}

export const deleteCachedOccupantProducts = async (guiid: string, callback: () => void) => {
    const length = (await caches.keys()).length;
    caches.keys().then((arrayKeys) => {
        arrayKeys.forEach(async (key, i) => {
            const id = i + 1;
            if (key.toLowerCase().includes(guiid)) {
                await caches.delete(key)
            }

            if (length === id) {
                callback();
            }
        })
    })
}

export const deleteCacheByName = async (name: string) => {
    await caches.delete(name)
}
